import Image from './Image';
import Group from './Group';
Image.Group = Group;
Image.displayName = 'ShineoutImage';
Image.Group.displayName = 'ShineoutImageGroup';
export default Image;